import {HttpClient, HttpEvent, HttpHeaders, HttpResponse,} from '@angular/common/http';
import {Inject, Injectable, Optional} from '@angular/core';
import {Observable} from 'rxjs';
import {ScenarioDto} from '../model/scenarioDto';
import {Configuration} from '../configuration';
import {BASE_PATH} from '../variables';

@Injectable()
export class ClearingTicketForPartnershipService {
  protected baseConfigPath = '';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) baseConfigPath: string,
    @Optional() configuration: Configuration,
  ) {
    if (baseConfigPath) {
      this.baseConfigPath = baseConfigPath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.baseConfigPath =
        baseConfigPath || configuration.basePath || this.baseConfigPath;
    }
  }

  /**
   * List Scenarios
   * This operation lists all Scenarios with corresponding subscenarios.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public listScenarios(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ScenarioDto>>;
  public listScenarios(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ScenarioDto>>>;
  public listScenarios(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ScenarioDto>>>;
  public listScenarios(
    observe: any = 'body',
    reportProgress = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set(
        'Authorization',
        'Basic ' +
          btoa(this.configuration.username + ':' + this.configuration.password)
      );
    }

    // authentication (bearer) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = ['application/json;charset=utf-8'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];
    return this.httpClient.request<Array<ScenarioDto>>(
      'get',
      `${this.baseConfigPath}/troubleTicket/scenarios`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
